<template>
    <div>
        <el-row :gutter="10">
            <el-col class='header-left' :span='7'>
                <h4>CottonGame</h4>
            </el-col>
            <el-col class='header-right' :span='17'>
                <ul>
                    <!--<li v-for='(item, index) in customerList'>-->
                    <!--    <a :href='`https://wpa.qq.com/msgrd?v=3&uin=${item.account}&site=qq&menu=yes&jumpflag=1`'-->
                    <!--       target='_blank'>客服QQ: {{ item.account }}</a>-->
                    <!--</li>-->
                    <li class='contact-pc-only'>
                        <a href='mailto:contact@cottongame.com'
                           target='_blank'>{{ $t('header.customerAccount') || '联系我们' }}: contact@cottongame.com</a>
                    </li>
                    <li class='region-switch'>
                        <el-dropdown @command='handleRegionChange' trigger='click'>
                            <span class='region-trigger'>
                                <svg xmlns='http://www.w3.org/2000/svg' width='16' height='16' viewBox='0 0 24 24'
                                     fill='none' stroke='currentColor' stroke-width='2' stroke-linecap='round'
                                     stroke-linejoin='round' class='header-icon'><rect width='20' height='8' x='2' y='2'
                                                                                       rx='2' ry='2' /><rect width='20'
                                                                                                             height='8'
                                                                                                             x='2'
                                                                                                             y='14'
                                                                                                             rx='2'
                                                                                                             ry='2' /><line
                                    x1='6' x2='6.01' y1='6' y2='6' /><line x1='6' x2='6.01' y1='18' y2='18' /></svg>
                                {{ $t('header.region') || '服务器' }}: {{ currentRegionLabel }}
                                <i class='el-icon-arrow-down el-icon--right'></i>
                            </span>
                            <el-dropdown-menu slot='dropdown'>
                                <el-dropdown-item
                                    command='cn'
                                    :class="{ 'is-active': currentRegion === 'cn' }">
                                    {{ $t('header.china') || '中国' }}
                                </el-dropdown-item>
                                <el-dropdown-item
                                    command='oversea'
                                    :class="{ 'is-active': currentRegion === 'oversea' }">
                                    {{ $t('header.overseas') || '海外' }}
                                </el-dropdown-item>
                            </el-dropdown-menu>
                        </el-dropdown>
                    </li>
                    <li class='lang-switch'>
                        <el-dropdown @command='handleLanguageChange' trigger='click'>
                            <span class='lang-trigger'>
                                <svg xmlns='http://www.w3.org/2000/svg' width='16' height='16' viewBox='0 0 24 24'
                                     fill='none' stroke='currentColor' stroke-width='2' stroke-linecap='round'
                                     stroke-linejoin='round' class='header-icon'><path d='m5 8 6 6' /><path
                                    d='m4 14 6-6 2-3' /><path d='M2 5h12' /><path d='M7 2h1' /><path
                                    d='m22 22-5-10-5 10' /><path d='M14 18h6' /></svg>
                                {{ currentLangLabel }}
                                <i class='el-icon-arrow-down el-icon--right'></i>
                            </span>
                            <el-dropdown-menu slot='dropdown'>
                                <el-dropdown-item
                                    v-for='item in localeOptions'
                                    :key='item.value'
                                    :command='item.value'
                                    :class="{ 'is-active': currentLocale === item.value }">
                                    {{ item.label }}
                                </el-dropdown-item>
                            </el-dropdown-menu>
                        </el-dropdown>
                    </li>
                </ul>
            </el-col>
        </el-row>
    </div>
</template>

<script>
import { defineComponent } from 'vue';
import { customerApi } from '@/service/api/customerApi';
import { getLocale, localeOptions, setLocale } from '@/locales';
import { localStg } from '@/utils/storage/local';
import { EnumLocalStore } from '@/constant/enums';

export default defineComponent({
    name: 'CottonHeader',
    data() {
        return {
            customerList: [],
            currentLocale: getLocale(),
            localeOptions: localeOptions
        }
    },
    computed: {
        currentLangLabel() {
            const current = this.localeOptions.find(item => item.value === this.currentLocale);
            return current ? current.label : '中文';
        },
        currentRegion() {
            return localStg.get(EnumLocalStore.region) !== 'oversea' ? 'cn' : 'oversea';
        },
        currentRegionLabel() {
            return this.currentRegion === 'cn' ? (this.$t('header.china') || '中国') : (this.$t('header.overseas') || '海外');
        }
    },
    created() {
        this.getList()
    },
    methods: {
        getList() {
            customerApi.getCustomer({account: ""}).then(result => {
                if (result.code === 200) {
                    this.customerList = result.data.records
                }
            })
        },
        handleLanguageChange(locale) {
            setLocale(locale);
            this.currentLocale = locale;
            // 刷新页面以应用新语言
            window.location.reload();
        },
        handleRegionChange(region) {
            // 如果选择的区域与当前区域相同，不做任何操作
            if (region === this.currentRegion) {
                return;
            }
            
            const regionName = region === 'cn'
                ? (this.$t('header.china') || '中国')
                : (this.$t('header.overseas') || '海外');
            const confirmMsg = this.$t('header.confirmSwitchRegion', { region: regionName })
                || `切换服务器后需要重新登录，是否确认切换到「${regionName}」服务器?`;
            
            this.$modal.confirm(confirmMsg).then(() => {
                this.currentRegion = region;
                // 保存区域设置到本地存储
                localStg.set(EnumLocalStore.region, region);
                // 清除登录信息
                localStg.remove(EnumLocalStore.jwtTokenName);
                // 刷新页面以应用新区域
                window.location.reload();
            }).catch(() => {
                // 用户取消，不做任何操作
            });
        }
    }
});
</script>

<style scoped lang='css'>
.header-right ul {
    width: 100%;
    text-align: right;
}

.header-right li {
    display: inline-block;
    margin-left: 1rem;
}

.header-right li a {
    color: #fff;
}

.lang-switch, .region-switch {
    cursor: pointer;
}

.lang-trigger, .region-trigger {
    color: #fff;
    cursor: pointer;
    display: inline-flex;
    align-items: center;
}

.lang-trigger:hover, .region-trigger:hover {
    opacity: 0.8;
}

.lang-trigger i, .region-trigger i {
    margin-right: 4px;
}

.header-icon {
    margin-right: 4px;
    vertical-align: middle;
}

/* PC端显示，手机端隐藏 */
@media (max-width: 768px) {
    .contact-pc-only {
        display: none !important;
    }
}
</style>
